import { motion } from "framer-motion";
import ThemeBg from "../../../app/assets/images/storyMagic/storyThemeBG.svg";
import Theme from "../../../app/assets/images/storyMagic/story-theme.png";
import BirdIcon from "../../../app/assets/images/storyMagic/bird2.svg";

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const StoryThemeSection = () => {
  return (
    <motion.div
      className="pt-11 items-center flex flex-col"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
    >
      <motion.h3
        className="text-3xl sm:text-[56px] uppercase font-bold relative leading-none mb-1.5 pb-6"
        variants={fadeInUp}
      >
        Your Story Theme
        <div className="bg-[#7F51D5] w-[85%] h-2 absolute mx-auto left-0 right-0 bottom-0"></div>
      </motion.h3>
      <motion.div
        className="relative z-0 w-full flex justify-center px-8"
        variants={scaleIn}
      >
        <div className="relative">
          <motion.img
            src={Theme}
            className="-mb-[6%]"
            alt=""
            variants={scaleIn}
          />
          <motion.img
            src={BirdIcon}
            className="absolute w-[15%] -top-[13%] -left-[5%]"
            alt=""
            initial={{ opacity: 0, y: -30, x: -30, scale: 0.5 }}
            whileInView={{
              opacity: 1,
              y: 0,
              x: 0,
              scale: 1,
            }}
            viewport={{ once: false }}
            animate={{
              y: [0, -20, 0],
              x: [0, 10, 0],
              rotate: [0, -10, 10, 0],
            }}
            transition={{
              opacity: { delay: 0.4, duration: 0.8, ease: "easeOut" },
              scale: { delay: 0.4, duration: 0.8, ease: "easeOut" },
              x: { delay: 0.4, duration: 0.8, ease: "easeOut" },
              y: {
                delay: 1.2,
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              },
              rotate: {
                delay: 1.2,
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }}
          />
        </div>
        <motion.img
          className="absolute w-full inset-0 mt-auto z-[-1]"
          src={ThemeBg}
          alt=""
          variants={fadeIn}
        />
      </motion.div>
    </motion.div>
  );
};

export default StoryThemeSection;
